import Button from "../../Button/Button";
import "./vehicleCardSuccess.css";
import { useDispatch } from "react-redux";
import {
  setCurrentPage,
  setUserTestDriveInfo
} from "../../../redux-sagas/actions/index";
import { getTranslation } from "../../../utils/getTranslation";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import DynamicIcon from "../../Icons/DynamicIcon";

const VehicleCardSuccess = ({ handleBack, bookingData }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const handleViewTestDrives = () => {
    dispatch(
      setUserTestDriveInfo({
        documentTypeId: bookingData.documentTypeId,
        documentNum: bookingData.documentNumber,
        email: bookingData.email
      })
    );
    dispatch(setCurrentPage("test-drives"));
  };

  return (
    <div className="vehicle-success align-items-md-center">
      <h3 className="reservationTitle text-center text-lg-start">
        {getTranslation("Successful reservation!", t)}
      </h3>
      <div className="reserve-info">
        <div className="col-one">
          <p className="reserve-info">{getTranslation("Reservation information", t)}</p>
          <div>
            <DynamicIcon name="location" />
            <span>{bookingData.showroomName}</span>
          </div>
          <div>
            <DynamicIcon name="calendar" />
            <span>{format(new Date(bookingData.bookingDate), 'dd/MM/yyyy')}</span>
          </div>
          <div>
            <DynamicIcon name="clock" />
            <span>{bookingData.startTimeFormatted}</span>
          </div>
        </div>
        <div className="col-two">
          <p className="contact-info">{getTranslation("Contact information", t)}</p>
          <div>
            <DynamicIcon name="person" />
            <span>{bookingData.firstname + " " + bookingData.lastname}</span>
          </div>
          <div>
            <DynamicIcon name="telephone" />
            <span>{bookingData.phoneNumber}</span>
          </div>
          <div>
            <DynamicIcon name="mail" />
            <span>{bookingData.email}</span>
          </div>
        </div>
      </div>
      <div className="buttons align-self-center align-self-lg-end d-flex gap-3">
        <Button
          type="secondary"
          text="View my Test Drive"
          handleClick={handleViewTestDrives}
        />
        <Button type="primary" text="Return" handleClick={handleBack} />
      </div>
    </div>
  );
};

export default VehicleCardSuccess;
